module.exports = __webpack_public_path__ + "img/why-icon-4.8f7600da.svg";